import {checkError, closeAlert, receiveErrorAlert} from "../commonsActions";
import {downloadPlayerActiveSalesPointsCsv, getPlayerActiveSalesPoints} from "../../helpers/playerStatsService";

export const FETCH_PLAYER_ACTIVE_SALES_POINTS_BEGIN = 'FETCH_PLAYER_ACTIVE_SALES_POINTS_BEGIN';
export const FETCH_PLAYER_ACTIVE_SALES_POINTS_SUCCESS = 'FETCH_PLAYER_ACTIVE_SALES_POINTS_SUCCESS';
export const FETCH_PLAYER_ACTIVE_SALES_POINTS_ERROR = 'FETCH_PLAYER_ACTIVE_SALES_POINTS_ERROR';

const fetchPlayerActiveSalesPointsSuccess = res => ({
    type: FETCH_PLAYER_ACTIVE_SALES_POINTS_SUCCESS,
    payload: {
        playerActiveSalesPoints: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPlayerActiveSalesPointsError = error => ({
    type: FETCH_PLAYER_ACTIVE_SALES_POINTS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPlayerActiveSalesPoints = query => dispatch => {
    dispatch({type: FETCH_PLAYER_ACTIVE_SALES_POINTS_BEGIN});
    return getPlayerActiveSalesPoints(query).then(res => {
        dispatch(fetchPlayerActiveSalesPointsSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPlayerActiveSalesPointsError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchPlayerActiveSalesPointsCsv = query => dispatch => {
    return downloadPlayerActiveSalesPointsCsv(query).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/player/playerActiveSalesPointsActions.js